import { createReducer } from '@reduxjs/toolkit';

import { GlobalState } from '../../../types.global';

import * as actions from './actions';
import { fetchBanners } from './thunks';
import { BannerState } from './types';

export const getInitialBannerState = (state: GlobalState): BannerState => {
  const { banner } = state;
  const disabledUntil = banner?.disabledUntil;

  return {
    list: [],
    savedAt: null,
    clickedCount: 0,

    ...banner,
    disabledUntil: (() => {
      if (disabledUntil === -1) return disabledUntil;
      return ((disabledUntil || 0) > Date.now()) ? disabledUntil : null;
    })(),
  };
};

const reducer = createReducer(null, (builder) => {
  builder.addCase(actions.clickedAd, (state) => {
    state.clickedCount++;
  });

  builder.addCase(actions.disabledUntil, (state, { payload }) => {
    state.disabledUntil = payload;
  });

  builder.addCase(fetchBanners.fulfilled, (state: BannerState, { payload }) => {
    if (payload) {
      state.savedAt = payload.savedAt;
      state.list = (payload.list || [])
    }
  });
});

export default reducer;
